


































import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'
import { AppModule } from '@/store/modules/app';
import Vue2Filters from 'vue2-filters'
import { PaintingByNumbersModule, PaintingFormat } from '../../../store/modules/paintingByNumbers'
import { AssetsModule } from '@/store/modules/asset'
import { ToolbarDeactivations, ToolbarModule } from '@/store/modules/toolbar'
import { ErrorsModule } from '@/store/modules/error'
import i18n from '@/i18n'

Vue.use(Vue2Filters)

@Component({
    name: 'painting-by-numbers-headline'
})

export default class PaintingByNumbersHeadline extends Vue {
    private fontSize = '20px'
    private showModal = false
    private tempParts = '0'
    private currentParts = PaintingByNumbersModule.parts
    private selected = PaintingByNumbersModule.parts
    private priceInitialised = false

    @Prop() private titleKey!:string
    get price() {
        if (AppModule.session.products !== undefined){
            for (let i = 0; i < AppModule.session.products.length; i++){
                if (AppModule.session.products[i].itemId === AppModule.productID){
                    let price = AppModule.session.products[i].price
                    if (price !== undefined){
                        return price.price
                    }
                }
            }
        }
        return ""
    }

    @Watch('price')
    onPriceChanged(price: number){
        if (this.priceInitialised) {
            this.fontSize = '26px'
            setTimeout(() => this.fontSize = '20px', 1000);
        }
        if (price !== undefined && price.toString() !== "") {
            this.priceInitialised = true
        }
    }

    @Watch('parts')
    partsChanged(newParts: string) {
        this.currentParts = newParts
        this.selected = newParts
    }

    get currencySymbol() {
        if(AppModule.session.products && AppModule.session.products.length > 0 && AppModule.session.products[0].price) {
            if(AppModule.session.products[0].price.currency == "EUR") return "€"
            if(AppModule.session.products[0].price.currency == "USD") return "$"
            if(AppModule.session.products[0].price.currency == "GBP") return "£"
            if(AppModule.session.products[0].price.currency == "CHF") return "SFr. "
            return AppModule.session.products[0].price.currency
        }
        return ""
    }
    
    get currencyFilterOptions() {
        if(AppModule.session.products && AppModule.session.products.length > 0 && AppModule.session.products[0].price) {
            if(AppModule.session.products[0].price.currency == "EUR") return {thousandsSeparator: '.',decimalSeparator: ',', symbolOnLeft: false, spaceBetweenAmountAndSymbol: true}
            if(AppModule.session.products[0].price.currency == "USD") return {}
        }
        return {}
    }

    get partsOptions() {
        return PaintingByNumbersModule.availableParts
    }

    get showGiftOptions() {
        return AppModule.showGiftOptions
    }

    get parts() {
        return PaintingByNumbersModule.parts
    }

    get deliveryCountry() {
        if (AppModule.session.deliveryCountry) {
            return i18n.t(AppModule.session.deliveryCountry.toLowerCase())
        }
        return ""
    }
    
    showShippingCost() {
        AppModule.SetShowShippingOverlay(true)
    }

    setSelectedItem(selected: string) {
        this.tempParts = selected
        this.showModal = true
    }

    hideModal() {
        this.showModal = false
        this.selected = this.currentParts
    }

    toggleModal() {
        //PaintingByNumbersModule.SetActiveCollage(1)
        this.fontSize = '26px'
        PaintingByNumbersModule.SetParts(this.tempParts)
        setTimeout(() => this.fontSize = '20px', 1000);
        this.showModal = false
        this.currentParts = this.tempParts
        this.resetCustomPuzzle()
    }

    deleteAllUsages() {
        Object.keys(PaintingByNumbersModule.activeAssets).forEach(key => {
            PaintingByNumbersModule.UnsetActiveAsset(key)
        })
        AssetsModule.ClearAssets(true)
        AssetsModule.ClearValidAssets(true)
        AssetsModule.ClearSelectedAssets(true)
        Object.keys(PaintingByNumbersModule.paintingUsageAndInfo).forEach(key => {
            PaintingByNumbersModule.ClearAllCollages(key)
        })
        Object.keys(PaintingByNumbersModule.persistedAssets).forEach(key => {
            PaintingByNumbersModule.ClearPersistedAssetData(key)
        })
    }

    resetToolbarErrorKeys(){
        for(let i = 0; i < ToolbarModule.errorKeys.length; i++){
            ToolbarModule.UnsetErrorKey(ToolbarModule.errorKeys[i])
        }
    }

    resetErrorModule(){
        Object.keys(ErrorsModule.keys).forEach(key => {
            ErrorsModule.SetError({ key: ErrorsModule.keys[Number(key)] })
        })
    }

    resetCustomPuzzle() {
        PaintingByNumbersModule.SetTitle('')
        PaintingByNumbersModule.SetUserInputTitle('')
        PaintingByNumbersModule.SetBoxDesign(1)
        PaintingByNumbersModule.SetPaintingFormat(PaintingFormat.LANDSCAPE)
        PaintingByNumbersModule.SetUserFormat("")
        PaintingByNumbersModule.SetShowOverlayUpload(false)
        PaintingByNumbersModule.SetStepsReseted(!PaintingByNumbersModule.stepsReseted)
        this.deleteAllUsages()
        AppModule.ResetSteps(true)
        ToolbarModule.SetDeactivated(ToolbarDeactivations.ZoomAndRotation | ToolbarDeactivations.Deletion)
        ToolbarModule.SetToolbarError(false)
        this.resetToolbarErrorKeys()
        this.resetErrorModule()
        AppModule.SetActiveStep(0)
        AppModule.SetHidePreviewButton(true)
    }
}
